import React from 'react';
import EventSponsorContainer from '../../../Containers/UserContainer/EventSponsor';

const EventSponsorScreen = () => {
  return <EventSponsorContainer />;
};

export default EventSponsorScreen;
